import React, {useEffect, useRef } from 'react';

const ScriptTag = (props) => {
    const inputRef = useRef();
    const id = Math.random().toString();

    useEffect(() => {
        const script = document.createElement("script");
        script.src = props.src;
        script.async = props.async || false;
        script.defer = props.defer || false;
        script.crossOrigin = props.crossOrigin || "";
        script.innerHTML = props.innerHTML || "";

        document.getElementById(id).replaceWith(script)
    }, [inputRef]);    // Only fired on Mount

    return (
        <div id={id} ref={inputRef} />
    );
};

export default ScriptTag;